// Mindestzahl an Registrierungen (Quelle Registrations) bzw. erkannten Laeufen
// (Quelle Main), ab der eine Aufgabe in Process Explorer und KPI Matrix erscheint.
// Nutzervorgabe 03.09.2026: ab 3 (vorher 5 im Process Explorer, keine in der Matrix).
export const MIN_TASK_EXECUTIONS = 3;
